<template>
  <section
    class="section"
    :id="id || null"
    :data-section-id="id || null"
    :style="{ marginTop }"
  >
    <SectionHead
      v-if="!hideHead"
      :title="title"
      :badge="badge"
      :accent="accent"
      :icon="icon"
      :collapsible="collapsible"
      :open="open"
      @toggle="toggleOpen"
    >
      <template v-if="$slots.summary" #summary>
        <slot name="summary" />
      </template>
      <slot name="head-right" />
    </SectionHead>

    <div v-show="!collapsible || open" class="section-body">
      <slot />
    </div>
  </section>
</template>

<script setup>
import { ref, watch } from 'vue'
import SectionHead from '@/components/ui/SectionHead.vue'

const props = defineProps({
  title: { type:String, required:true },
  badge: { type:String, default:'' },
  accent:{ type:String, default:'var(--stora-accent)' },
  marginTop: { type:String, default:'50px' },
  id: { type:String, default:'' },
  icon: { type:String, default:'' },
  collapsible: { type:Boolean, default:false },
  defaultOpen: { type:Boolean, default:true },
  // Skip the header entirely (used by Explore's sub-tabs, where the pill already
  // names the zone type — the header would be a duplicate).
  hideHead: { type:Boolean, default:false }
})

const emit = defineEmits(['update:defaultOpen'])

const open = ref(props.defaultOpen)
// Emit on user toggle so a parent binding with v-model:default-open stays in
// sync — otherwise the parent's record drifts after a manual collapse, and a
// jump-nav click that re-sets it `true` is a no-op (already true) and can't
// re-open the section.
function toggleOpen(){ open.value = !open.value; emit('update:defaultOpen', open.value) }

// allow parent to programmatically expand (e.g., when its anchor is clicked)
watch(() => props.defaultOpen, v => { open.value = v })

defineExpose({ open, toggleOpen, expand: () => { open.value = true } })
</script>

<style scoped>
.section-body{
  /* keep ChartGrid spacing intact */
}
</style>
